import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
  },
  submitButton: {
    width: '100%',
    marginTop: '1rem',
    borderRadius: '2rem',
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    backgroundColor: '#024C7A',
    color: 'white',

    '&:hover': {
      backgroundColor: '#024C7A',
    },
  },
}));

export default useStyles;
